// src/hooks/useWindowWidth.ts
"use client";
import { useState, useEffect } from "react";

function useWindowWidth(): number {
  const [windowWidth, setWindowWidth] = useState<number>(0);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () =>
      typeof window != "undefined" && setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // 초기 너비 설정
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
}

export default useWindowWidth;
